import { render, staticRenderFns } from "./s_ElCarouselV2.vue?vue&type=template&id=779405f4"
import script from "./s_ElCarouselV2.vue?vue&type=script&lang=js"
export * from "./s_ElCarouselV2.vue?vue&type=script&lang=js"
import style0 from "./s_ElCarouselV2.vue?vue&type=style&index=0&id=779405f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports